module.exports = __webpack_public_path__ + "img/ico-stop.b9a1133d.svg";